import React, { useState } from 'react';
import Complaint from'../assets/images/complaint.jpg'
import './home.css';

function Complains() {

  return (
 <section className="hero-banner-contect">
        <div className="hero-content-wrapper">
          <div className="complains-text">
            <p className="complains-label">Complaints Procedure</p>
             <h1>We take all complaints seriously and are committed to resolving issues promptly and fairly.</h1>

          <p className="complaint-description">
            If you wish to make a complaint, you can contact us by email at 
            <strong> info@orbitenergy.solutions</strong> or by phone on 
            <strong> 0330 058 1634</strong>.  
            Once we receive your complaint, our team will review it and the matter will be overseen by our company director.

            <br /><br />

            We aim to provide a full response within <strong>10 working days</strong>.  
            If you feel that the outcome is still not satisfactory, you may escalate your complaint to the 
            <strong> Ombudsman Services</strong>, who are completely independent and free for consumers.

            <br /><br />
            <strong>The following are the Ombudsman services contact details:</strong>

            <br /><br />
            <ul className="ombudsman-list">
                <li>Website: <a href="https://www.energyombudsman.org" target="_blank" rel="noreferrer">www.energyombudsman.org</a></li>
                <li>Email: enquiry@energyombudsman.org</li>
                <li>Phone: 0330 440 1624 (Monday to Friday, 8am–8pm, and Saturday, 9am–1pm)</li>
            </ul>
          </p>
          </div>
          <div className="complaint-image">
            <div className="complain-blob">
              <img src={Complaint} alt="Business owners" />
            </div>
          </div>
        </div>
      </section>
  );
}

export default Complains;